import { type ReactNode } from 'react';
import { useLocalePreference } from '../../i18n/useLocalePreference';

interface LocaleProviderProps {
  children: ReactNode;
}

/**
 * Boot-time locale bootstrapper. Runs `useLocalePreference` so the stored
 * preference is applied to i18next before the rest of the tree renders
 * translation-dependent UI. Renders children unchanged.
 *
 * Wave B will wrap this around <App /> in main.tsx.
 */
export function LocaleProvider({ children }: LocaleProviderProps) {
  // Side-effect only: applies stored/navigator locale and subscribes to changes.
  useLocalePreference();
  return <>{children}</>;
}

export default LocaleProvider;
